import { EntityChanged, RelodeApiError } from "@relode/core";
import { IClientProfile } from "../../../shared/types/profile/IClientProfile";

export interface SettingsState {
    ui: {
        isBusy: boolean;
        error: RelodeApiError;
        selectedTab: string;
        changed: EntityChanged<IClientProfile>;
    };
    data: {
        client: IClientProfile;
    };
}

export const initialState: SettingsState = {
    ui: {
        isBusy: false,
        error: undefined,
        selectedTab: "contact",
        changed: {},
    },
    data: { client: undefined },
};
